import { render, staticRenderFns } from "./hEalthCard.vue?vue&type=template&id=66b72308&scoped=true"
import script from "./hEalthCard.vue?vue&type=script&lang=js"
export * from "./hEalthCard.vue?vue&type=script&lang=js"
import style0 from "./hEalthCard.vue?vue&type=style&index=0&id=66b72308&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b72308",
  null
  
)

export default component.exports